import React, {useState, useCallback} from "react";
import {Button, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";
import {useObserver} from "mobx-react-lite";

export function CustomerApplyButton({courierName, deliveryId, courierId, setRecall}) {
    const stores = useStore();
    const [visible, setVisible] = useState(false);
    const {t} = useTranslation();

    const handleSubmit = useCallback(async () => {
        await stores.orderStore
            .approveAssignRequest({
                deliveryId: deliveryId,
                courierId: courierId
            })
            .then(() => {
                setRecall(prev => !prev);
                setVisible(false);
            });
    }, [deliveryId, courierId, setRecall, setVisible]);
    const handleReject = useCallback(async () => {
        await stores.orderStore
            .rejectAssignRequest({
                deliveryId: deliveryId,
                courierId: courierId
            })
            .then(() => {
                setRecall(prev => !prev);
                setVisible(false);
            });
        setRecall(prev => !prev);
        setVisible(false);
    }, [deliveryId, courierId, setRecall, setVisible]);

    const handleCancel = useCallback(() => {
        setVisible(false);
    }, [setVisible]);

    return useObserver(() => {
        return (
            <div>
                <Modal
                    visible={visible}
                    centered
                    title={t("approveConfirmMessage", {ns: "shiftSuggestion"})}
                    data-testid="courierApplyModal"
                    onCancel={handleCancel}
                    footer={[
                        <Button key="reject" type="primary" danger onClick={handleReject}>
                            Reddet
                        </Button>,
                        <Button key="approve" type="primary" onClick={handleSubmit}>
                            Onayla
                        </Button>
                    ]}
                >
                    Seçilen Sipariş "{courierName}" isimli kuryeye atanacaktır
                    <br />
                    Onaylıyor musunuz?
                </Modal>
                <div>{courierName}</div>
                <Button type="primary" onClick={() => setVisible(true)}>
                    Onayla
                </Button>
            </div>
        );
    });
}
